'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' });

var Landscape = function Landscape(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Landscape = (0, _pure2.default)(Landscape);
Landscape.muiName = 'SvgIcon';

exports.default = Landscape;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Landscape.js
// module id = 2530
// module chunks = 0